var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareEmail = function SvgShareEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 58 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.67 22.34 29 34.08 15.33 22.27v15.47h27.34Zm-2.19-2.08H17.59L29 30.12ZM29 0a29 29 0 1 0 29 29A29 29 0 0 0 29 0m16.67 40.74H12.33V17.26h33.34Z"
  })));
};
export default SvgShareEmail;